
import './scripts/animations';
import './scripts/triggers';
import './scripts/ajaxLoader';
import './scripts/pricing';
import './scripts/_hero-carousel';
import './scripts/_contact';
import './scripts/_customer_stories';
import './scripts/components/accordion';
import './scripts/_app';
import Slider from './scripts/components/slider';

document.addEventListener('DOMContentLoaded', () => {
    window.slider = new Slider('.slider');
});